var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "table-header" }, [
        _c(
          "div",
          [
            _c(
              "el-radio-group",
              {
                staticStyle: { "margin-bottom": "20px" },
                on: { change: _vm.handleTabChange },
                model: {
                  value: _vm.tabPosition,
                  callback: function($$v) {
                    _vm.tabPosition = $$v
                  },
                  expression: "tabPosition"
                }
              },
              [
                _c("el-radio-button", { attrs: { label: "在职" } }, [
                  _vm._v("在职")
                ]),
                _c("el-radio-button", { attrs: { label: "离职" } }, [
                  _vm._v("离职")
                ])
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.tableData,
            "header-cell-style": _vm.headerStyle,
            "row-class-name": _vm.tableRowClassName
          }
        },
        [
          _c("el-table-column", {
            attrs: {
              label: "序号",
              align: "center",
              width: "80",
              type: "index"
            }
          }),
          _c("el-table-column", {
            attrs: {
              prop: "name",
              label: "姓名",
              align: "center",
              width: "100"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.name || "-"))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "idCard",
              label: "身份证",
              align: "center",
              width: "180"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.idCard || "-"))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "phone",
              label: "电话",
              align: "center",
              width: "120"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.phone || "-"))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "area",
              label: "合作区域/园区",
              align: "center",
              width: "150"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.region_fill && scope.row.region_fill.length
                      ? _c(
                          "div",
                          { staticClass: "tag-container" },
                          _vm._l(
                            typeof scope.row.region_fill === "string"
                              ? scope.row.region_fill.split(",")
                              : scope.row.region_fill,
                            function(skill, index) {
                              return _c(
                                "el-tag",
                                {
                                  key: index,
                                  staticClass: "skill-tag",
                                  attrs: { size: "small", type: "success" }
                                },
                                [_vm._v(_vm._s(skill))]
                              )
                            }
                          ),
                          1
                        )
                      : _c("div", [_vm._v("-")])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "personnel_category",
              label: "人员类别",
              align: "center",
              width: "180"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", { staticStyle: { color: "#219aff" } }, [
                      _vm._v(_vm._s(scope.row.personnel_category || "-"))
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { prop: "skill_tags", label: "技能标签", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.skill_tags && scope.row.skill_tags.length
                      ? _c(
                          "div",
                          { staticClass: "tag-container" },
                          _vm._l(
                            typeof scope.row.skill_tags === "string"
                              ? scope.row.skill_tags.split(",")
                              : scope.row.skill_tags,
                            function(skill, index) {
                              return _c(
                                "el-tag",
                                {
                                  key: index,
                                  staticClass: "skill-tag",
                                  attrs: { size: "small", type: "success" }
                                },
                                [_vm._v(_vm._s(skill))]
                              )
                            }
                          ),
                          1
                        )
                      : _c("div", [_vm._v("-")])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "status",
              label: "状态",
              align: "center",
              width: "80"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.status || "-"))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              prop: "remark",
              label: "备注",
              align: "center",
              width: "120"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.remark || "-"))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { label: "操作", align: "center", width: "120" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "el-dropdown",
                      {
                        on: {
                          command: function(command) {
                            return _vm.handleCommand(command, scope.row)
                          }
                        }
                      },
                      [
                        _c("span", { staticClass: "el-dropdown-link" }, [
                          _vm._v("\n            更多操作 "),
                          _c("i", {
                            staticClass: "el-icon-arrow-down el-icon--right"
                          })
                        ]),
                        _c(
                          "el-dropdown-menu",
                          { attrs: { slot: "dropdown" }, slot: "dropdown" },
                          [
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: "edit",
                                  disabled: !_vm.canEdit
                                }
                              },
                              [_vm._v("编辑")]
                            ),
                            _c(
                              "el-dropdown-item",
                              {
                                attrs: {
                                  command: "delete",
                                  disabled:
                                    !_vm.isAuthorizedUser() ||
                                    scope.row.status !== "离职" ||
                                    !_vm.canEdit
                                }
                              },
                              [_vm._v("删除")]
                            ),
                            _c(
                              "el-dropdown-item",
                              { attrs: { command: "history" } },
                              [_vm._v("历史记录")]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.pageParams.skip,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.pageParams.limit,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        ],
        1
      ),
      _c("history-dialog", {
        attrs: {
          visible: _vm.historyDialogVisible,
          "employee-id": _vm.currentEmployeeId
        },
        on: {
          "update:visible": function($event) {
            _vm.historyDialogVisible = $event
          }
        }
      }),
      _c(
        "el-drawer",
        {
          attrs: {
            title: _vm.isEdit ? "编辑专职专项人员" : "添加专职专项人员",
            visible: _vm.dialogVisible,
            direction: "rtl",
            size: "30%",
            "before-close": _vm.handleClose
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "employeeForm",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-width": "120px",
                    "label-position": "right"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "姓名", prop: "name", required: "" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入姓名" },
                        model: {
                          value: _vm.form.name,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "name", $$v)
                          },
                          expression: "form.name"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "身份证", prop: "id_card", required: "" }
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入身份证" },
                        model: {
                          value: _vm.form.id_card,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "id_card", $$v)
                          },
                          expression: "form.id_card"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "电话", prop: "phone", required: "" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form.phone,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "phone", $$v)
                          },
                          expression: "form.phone"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "合作区域/园区", prop: "region_fill" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { multiple: "", placeholder: "请选择" },
                          on: { focus: _vm.handleSelectFocus },
                          model: {
                            value: _vm.form.region_fill,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "region_fill", $$v)
                            },
                            expression: "form.region_fill"
                          }
                        },
                        _vm._l(_vm.campusOptions, function(item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: Object.values(item)[0],
                              value: Object.values(item)[0]
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "人员类别", prop: "personnel_category" }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请选择" },
                          model: {
                            value: _vm.form.personnel_category,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "personnel_category", $$v)
                            },
                            expression: "form.personnel_category"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: {
                              label: "专职专项（资源池白名单）",
                              value: "专职专项（资源池白名单）"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "技能标签" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { multiple: "", placeholder: "请选择" },
                          model: {
                            value: _vm.form.skill_tags,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "skill_tags", $$v)
                            },
                            expression: "form.skill_tags"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "网络复检", value: "网络复检" }
                          }),
                          _c("el-option", {
                            attrs: { label: "服务器专项", value: "服务器专项" }
                          }),
                          _c("el-option", {
                            attrs: { label: "资源交付", value: "资源交付" }
                          }),
                          _c("el-option", {
                            attrs: { label: "特殊变更", value: "特殊变更" }
                          }),
                          _c("el-option", {
                            attrs: { label: "裁撤相关", value: "裁撤相关" }
                          }),
                          _c("el-option", {
                            attrs: { label: "改造", value: "改造" }
                          }),
                          _c("el-option", {
                            attrs: { label: "资产", value: "资产" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "状态", required: "" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { placeholder: "请选择" },
                          model: {
                            value: _vm.form.status,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "status", $$v)
                            },
                            expression: "form.status"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "在职", value: "在职" }
                          }),
                          _c("el-option", {
                            attrs: { label: "离职", value: "离职" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { "text-align": "right", "margin-top": "20px" }
                },
                [
                  _c("el-button", { on: { click: _vm.handleClose } }, [
                    _vm._v("取消")
                  ]),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSubmit }
                    },
                    [_vm._v("确定")]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }